import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const coinsChangesSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getAllCoins24hChanges: build.query<any, void>({
      query: () => `${urlConfig.tradesBaseUrl}/trades/rates/all/24h-changes`,
    }),
  }),
})

export const {
  useGetAllCoins24hChangesQuery,
} = coinsChangesSlice 